var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{staticClass:"cashierdiary--inpout",attrs:{"placeholder":'请输入' + _vm.td.columnName},on:{"focus":_vm.textFocus},model:{value:(_vm.editInput),callback:function ($$v) {_vm.editInput=$$v},expression:"editInput"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-543f19f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cashier/components/cashierdiaryTable/attr/c-text.vue
// module id = null
// module chunks = 